import { sizeTokenOptionsWithDefault } from './token-options.js';
export const TOAST_FIELDS = [
    {
        key: 'toast.durationMs',
        label: '토스트 표시 시간',
        help: '토스트(화면 위·아래에 잠깐 떴다 사라지는 짧은 안내, 예: "복사했습니다")가 떠 있는 시간입니다. 버튼이 있는 토스트는 아래 "버튼 있는 토스트 표시 시간"을 따릅니다.',
        group: '토스트',
        type: 'integer',
        defaultValue: 3000,
        min: 1000,
        max: 10000,
        unit: 'ms',
    },
    {
        key: 'toast.actionDurationMs',
        label: '버튼 있는 토스트 표시 시간',
        help: '오른쪽에 버튼(예: "보기")이 있는 토스트가 떠 있는 시간입니다. 버튼을 누를 시간을 주려고 보통 토스트보다 깁니다.',
        group: '토스트',
        type: 'integer',
        defaultValue: 5000,
        min: 1000,
        max: 15000,
        unit: 'ms',
    },
    {
        key: 'toast.sideMargin',
        label: '토스트 좌우 여백',
        help: '토스트와 화면 왼쪽·오른쪽 끝 사이의 여백입니다.',
        group: '토스트',
        type: 'size',
        tokenGroup: 'spacing',
        defaultValue: '$spacing.m-plus',
        min: 0,
        max: 48,
    },
    {
        key: 'toast.edgeOffset',
        label: '토스트 위·아래 거리',
        help: '위에 뜨는 토스트는 화면 위 안전 영역(상태 표시줄)에서, 아래에 뜨는 토스트는 화면 아래 안전 영역에서 이만큼 떨어져 뜹니다. 화면이 따로 더한 거리(하단 버튼 위로 띄우기 등)는 그대로 더해집니다.',
        group: '토스트',
        type: 'size',
        tokenGroup: 'spacing',
        defaultValue: '$spacing.m-plus',
        min: 0,
        max: 80,
    },
    {
        key: 'toast.radius',
        label: '토스트 모서리 둥글기',
        help: '토스트 상자 네 모서리의 둥글기입니다.',
        group: '토스트',
        type: 'enum',
        defaultValue: 'default',
        options: sizeTokenOptionsWithDefault('radius', '지금 모양 (앱 약 5px · 모바일 웹 6px)'),
    },
    {
        key: 'toast.backgroundOpacity',
        label: '토스트 바탕 불투명도',
        help: '토스트 바탕(테마의 반전 바탕색 — 라이트 테마는 검정 계열, 다크 테마는 흰색 계열)의 불투명도입니다. 클수록 뒤 화면이 덜 비칩니다.',
        group: '토스트',
        type: 'enum',
        defaultValue: '50',
        options: [
            { value: '30', label: '30%' },
            { value: '40', label: '40%' },
            { value: '50', label: '50%' },
            { value: '60', label: '60%' },
            { value: '70', label: '70%' },
            { value: '80', label: '80%' },
            { value: '90', label: '90%' },
            { value: '100', label: '100% (비치지 않음)' },
        ],
    },
    {
        key: 'toast.snackbar.durationMs',
        label: '앱 안 알림 표시 시간',
        help: '앱을 쓰는 중에 받은 푸시 알림을 화면 위에 카드로 보여 주는 "앱 안 알림"이 저절로 사라지기까지의 시간입니다. 위로 밀거나 누르면 바로 사라집니다.',
        group: '앱 안 알림',
        type: 'integer',
        defaultValue: 4000,
        min: 1000,
        max: 15000,
        unit: 'ms',
    },
    {
        key: 'toast.snackbar.topOffset',
        label: '앱 안 알림 위 거리',
        help: '앱 안 알림 카드가 화면 위 안전 영역(상태 표시줄)에서 떨어진 거리입니다.',
        group: '앱 안 알림',
        type: 'size',
        tokenGroup: 'spacing',
        defaultValue: '$spacing.s-plus',
        min: 0,
        max: 60,
    },
    {
        key: 'toast.snackbar.radius',
        label: '앱 안 알림 모서리 둥글기',
        help: '앱 안 알림 카드 네 모서리의 둥글기입니다.',
        group: '앱 안 알림',
        type: 'size',
        tokenGroup: 'radius',
        defaultValue: '$radius.m',
        min: 0,
        max: 32,
    },
    {
        key: 'toast.snackbar.padding',
        label: '앱 안 알림 안쪽 여백',
        help: '앱 안 알림 카드 테두리와 제목·내용 글자 사이의 여백(네 방향 같음)입니다.',
        group: '앱 안 알림',
        type: 'size',
        tokenGroup: 'spacing',
        defaultValue: '$spacing.m-plus',
        min: 4,
        max: 32,
    },
    {
        key: 'toast.snackbar.titleSize',
        label: '앱 안 알림 제목 글자 크기',
        help: '앱 안 알림 카드 첫 줄(알림 제목)의 글자 크기입니다.',
        group: '앱 안 알림',
        type: 'size',
        tokenGroup: 'fontSize',
        defaultValue: '$fontSize.sm-plus',
        min: 10,
        max: 24,
    },
    {
        key: 'toast.snackbar.bodySize',
        label: '앱 안 알림 내용 글자 크기',
        help: '앱 안 알림 카드 둘째 줄부터(알림 내용, 최대 2줄)의 글자 크기입니다.',
        group: '앱 안 알림',
        type: 'size',
        tokenGroup: 'fontSize',
        defaultValue: '$fontSize.sm',
        min: 10,
        max: 24,
    },
];
//# sourceMappingURL=toast.js.map